import { render, staticRenderFns } from "./vuetiform-element.vue?vue&type=template&id=5d713b59&"
import script from "./vuetiform-element.vue?vue&type=script&lang=js&"
export * from "./vuetiform-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports